import { CREATE_EMAIL_SEQUENCE_FROM_LEADS_IDS, CREATE_EMAIL_SEQUENCE_FROM_LEADS_IDS_PLACEHOLDER, GET_EMAIL_SEQUENCES_BY_SEQUENCE_ID, GET_EMAIL_SEQUENCES_LOGS_BY_SEQUENCE_ID, GET_EMAIL_SEQUENCE_SUMMARY_BY_SEQUENCE_ID, REMOVE_EMAIL_SEQUENCES_LEADS_IDS, EXECUTE_EMAIL_STEP, CHECK_IF_EMAIL_STEP_BOUNCED, CHECK_IF_EMAIL_STEP_REPLIED, RESET_EMAIL_STEP, GET_ADMIN_SCHEDULED_EMAILS, GET_ADMIN_EMAIL_SEQUENCES } from "../constants";
import Requests from "../requests";

const EmailSequenceService = {
    createEmailSequenceFromLeadsIdsUsingPlaceholder({ sequence_id, leads_id }) {
        return Requests.postWithAuth(CREATE_EMAIL_SEQUENCE_FROM_LEADS_IDS_PLACEHOLDER, { sequence_id, leads_id });
    },
    createEmailSequenceFromLeadsIds({ sequence_id, leads_id }) {
        return Requests.postWithAuth(CREATE_EMAIL_SEQUENCE_FROM_LEADS_IDS, { sequence_id, leads_id });
    },
    getEmailSequencesBySequenceId(sequence_id) {
        return Requests.getWithAuth(GET_EMAIL_SEQUENCES_BY_SEQUENCE_ID.replace(":id", sequence_id));
    },
    getEmailSequencesLogsBySequenceId(sequence_id) {
        return Requests.getWithAuth(GET_EMAIL_SEQUENCES_LOGS_BY_SEQUENCE_ID.replace(":id", sequence_id));
    },
    getEmailSequenceSummaryBySequenceId(sequence_id) {
        return Requests.getWithAuth(GET_EMAIL_SEQUENCE_SUMMARY_BY_SEQUENCE_ID.replace(":id", sequence_id));
    },
    removeLeadsFromSequence({ sequence_id, leads_id }) {
        return Requests.postWithAuth(REMOVE_EMAIL_SEQUENCES_LEADS_IDS, { sequence_id, leads_id });
    },
    executeEmailStep(step_id) {
        return Requests.postWithAuth(EXECUTE_EMAIL_STEP, { step_id });
    },
    checkIfEmailStepWasBounced(step_id) {
        return Requests.postWithAuth(CHECK_IF_EMAIL_STEP_BOUNCED, { step_id });
    },
    checkIfEmailStepWasReplied(step_id) {
        return Requests.postWithAuth(CHECK_IF_EMAIL_STEP_REPLIED, { step_id });
    },
    resetEmailStep(step_id) {
        return Requests.postWithAuth(RESET_EMAIL_STEP, { step_id });
    },
    getAdminScheduledEmails() {
        return Requests.getWithAuth(GET_ADMIN_SCHEDULED_EMAILS);
    },
    getAdminEmailSequences(page = 1, status) {
        let url = `${GET_ADMIN_EMAIL_SEQUENCES}?page=${page}`;
        if (status && status !== 'all') {
            url += `&status=${status}`;
        }
        return Requests.getWithAuth(url);
    }
};

export default EmailSequenceService;
